import { render, staticRenderFns } from "./MessageAction.vue?vue&type=template&id=0071cae3&"
import script from "./MessageAction.vue?vue&type=script&lang=js&"
export * from "./MessageAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports